module.exports = __webpack_public_path__ + "static/media/Hosting-wide.b348bcef.jpg";